export default __webpack_public_path__ + "alberta-patient-inactive.4be9d5f5bede7c3a9c6f.svg";